<mat-sidenav style="width: 50%" #sidenav mode="over" position="end" [opened]="sentMailDataSheetValue" disableClose>
  <div>
    <div class="sliding-sheet-header">
      <h4>Mail Details</h4>
      <button type="button" (click)="closeSentMailSheet()"><mat-icon>close</mat-icon></button>
    </div>

    <div class="row">
      <div class="col-md-12">
        <p class="receiver">
          To :<b class="pl-2">{{ clientDetails.email }}</b>
        </p>
        <p class="subject">
          Subject :<b class="pl-2">{{ sentMailData.subject }}</b>
        </p>
      </div>
    </div>
    <div #emailContent></div>
    <p *ngIf="fileList.length">Attachments</p>
    <!-- <div *ngFor="let file of fileList; let i = index">
      
      <p (click)="downloadFile(fileList[i].id)">{{ fileList[i].filename }}</p>
    </div> -->

    <div class="row" style="width: 100%">
      <div class="col-md-6 col-sm-6 col-12 pr-0" *ngFor="let file of fileList; let i = index">
        <mat-card class="card-lyout"
          ><mat-card-content
            ><mat-card-title class="Card-title">
              <div class="row">
                <div class="col-md-3 col-sm-3 col-3">
                  <img src="assets/images/pdf.png" width="40" />
                </div>
                <div class="col-md-7 col-sm-7 col-7 pl-1">
                  <h4 class="mb-1">{{ fileList[i].filename }}</h4>
                  <!-- <div class="file-sz">150kb</div> -->
                </div>
                <div class="col-md-2 col-sm-2 col-2">
                  <!-- <i class="material-icons mt-2 attachment" (click)="removeSelectedFile(index)"> cancel </i> -->
                </div>
              </div>
            </mat-card-title>
            <!--ng-container--></mat-card-content
          ></mat-card
        >
      </div>
    </div>
  </div>
</mat-sidenav>
